import styled from "styled-components";
import { COLOR } from "../../helpers/theme";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import imgIconArrowNormal from "../../static/icons/menu/next-normal.svg";
import { faBoxOpen, faCalendarCheck, faDoorOpen, faMapSigns, faPowerOff, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import getInitials from "../../helpers/getInitials";

interface Navigation {
  name: string;
  target: string;
  icon: IconDefinition;
}

const navMain = [
  {
    icon: faPowerOff,
    target: "/sign-out",
    name: "Keluar",
  },
  // {
  //   icon: faMapSigns,
  //   target: "/",
  //   name: "Direktori Layanan",
  // },
];

const navBuildingManagement = [
  {
    icon: faBoxOpen,
    target: "/building-management/inventories",
    name: "Inventaris",
  },
  {
    icon: faDoorOpen,
    target: "/building-management/rooms",
    name: "Ruangan",
  },
  {
    icon: faCalendarCheck,
    target: "/building-management/bookings",
    name: "Peminjaman Ruangan",
  },
]

const SidebarNavigation = () => {
  const location = useLocation();
  const authorizedUser = useSelector((state: RootState) => state.authorization.authorizedUser);

  const isNavigationActive = (target: string) => {
    const _target = target.split('/');
    const urls = location.pathname.split('/');
    const current = urls[2];
    if (!current && location.pathname !== '/') return "";
    if (`${current}` === _target[2]) {
      return "active";
    }
    return "";
  }

  const generateNavItems = () => {
    const generateDirectory = (() => {
      // const currentUrls = location.pathname.split('/');
      // switch (currentUrls[1]) {
      //   case '':
      //     return generateNavMenus([]);
      //   case 'building-management':
      //     return generateNavMenus(navBuildingManagement);
      // }
      return generateNavMenus(navBuildingManagement);
    });

    return (
      <React.Fragment>
        { generateNavMenus(navMain) }
        { generateDirectory() }
      </React.Fragment>
    )
  };

  const generateNavMenus = (navigation: Navigation[]) => {
    return navigation.map((item, index) => (
      <Link
        key={index}
        className={`navButton ${isNavigationActive(item.target)}`}
        to={item.target}
      >
        <div className="icon">
          <FontAwesomeIcon icon={item.icon} />
        </div>
        <span>{item.name}</span>
        <div className="icon-next">
          <img className="icon-hover" src={imgIconArrowNormal} alt="open-link" />
        </div>
      </Link>
    ));
  }

  const renderProfile = () => {
    if (!authorizedUser) return <div />;

    return (
      <div className="profile">
        <div className="profileDetail">
          <div className="avatar">
            <span>{getInitials(authorizedUser.name)}</span>
          </div>
          <div className="content">
            <h1>{authorizedUser.name}</h1>
            <h2>{authorizedUser.role_detail?.role_name}</h2>
          </div>
        </div>
      </div>
    );
  }

  return (
    <SidebarNavigationWrapper>
      { renderProfile() }
      <div className="navWrapper">
        {generateNavItems()}
      </div>
    </SidebarNavigationWrapper>
  );
};

export const SidebarNavigationWrapper = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  border-right: 1px solid #ebebeb;
  box-shadow: 0px 0px 5px 0px #ebebeb;

  @media print {
    display: none;
  }

  & > .profile {
    & > .profileDetail {
      display: flex;
      padding: 25px;
      align-items: center;
      padding-bottom: 25px;
      border-bottom: 1px solid ${COLOR.BORDER};

      & > .avatar {
        display: flex;
        color: #fff;
        margin-right: 20px;
        align-items: center;
        justify-content: center;
        background: linear-gradient(
          to bottom,
          var(--color-secondary) 0%,
          var(--color-secondary-dark) 100%
        );
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        line-height: 0px;
        border-radius: 100%;

        &.square {
          border-radius: 5px;
        }
      }

      & > .content {
        & > * {
          color: ${COLOR.BUTTON_TEXT};
        }

        h1 {
          font-size: 16px;
        }
        h2 {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }

  & .navWrapper {
    .navButton {
      display: flex;
      font-size: 16px;
      font-weight: 600;
      line-height: 100%;
      position: relative;
      align-items: center;
      text-decoration: none;
      transition: 0.15s all;
      color: ${COLOR.BUTTON_TEXT};
      padding: 15px 10px 15px 25px;
      border: 1px solid transparent;

      & > .icon-next {
        opacity: 0;
        right: 80px;
        position: absolute;
        transition: 0.15s all;
      }

      & > .icon-next > * {
        width: 12px;
        height: 12px;
      }

      & > .icon > * {
        display: block;
        width: 17px;
        height: 17px;
        margin-right: 15px;
      }

      & > .icon > .icon-hover {
        display: none;
      }

      &:hover {
        background-color: ${COLOR.BUTTON_FACE_HOVER};
      }

      &:hover,
      &.active {
        color: ${COLOR.PRIMARY};

        & > .icon-next {
          right: 20px;
          opacity: 1;
        }
      }
    }
  }
`;

export default SidebarNavigation;